import { Popover } from 'antd';

/**
 * A reusable wrapper around Ant Design's Popover component.
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.content - The content to display inside the popover.
 * @param {string|React.ReactNode} [props.title=''] - Optional title displayed at the top of the popover.
 * @param {'hover'|'focus'|'click'} [props.trigger='click'] - How the popover is triggered.
 * @param {'top'|'bottom'|'left'|'right'|'topLeft'|'topRight'|'bottomLeft'|'bottomRight'} [props.placement='top'] - Position of the popover relative to the target.
 * @param {React.ReactNode} props.children - The element that triggers the popover when interacted with.
 * @param {string} [props.className=''] - Optional CSS class for custom styling.
 *
 * @example
 * <AppPopover
 *   title="User Info"
 *   content={<div>Details go here</div>}
 *   trigger="hover"
 *   placement="right"
 * >
 *   <Button>Hover me</Button>
 * </AppPopover>
 */
export default function AppPopover({ content, title = '', trigger = 'click', placement = 'top', children, className = '' }) {
    return (
        <Popover content={content} title={title} trigger={trigger} placement={placement} className={className}>
            {children}
        </Popover>
    );
}
